import styled from "styled-components"
import { color } from "helpers/styled"
import PromoContainer from "../PromoContainer"

const SpecialPromotion = styled(PromoContainer)`
  color: ${color("darkBlue")};
  --promo-bg: linear-gradient(292deg, ${color("deepPink")} 4%, ${color("yellow")} 96%);
`

export default SpecialPromotion
